const UserDashboard = () => {
  return (
      <div className="right-sidebar candidate-rightwrapper">
        Dashboard
      </div>
  );
};
export default UserDashboard;
